export function parseBreastBox(value) {
  if (!Array.isArray(value) || value.length !== 4) return null;
  const [x, y, w, h] = value.map(Number);
  if (![x, y, w, h].every(Number.isFinite) || w <= 0 || h <= 0) return null;
  return { x, y, w, h };
}
